import type { BaseItemSchema } from "@memorang/types/src/session/new-session";
import type { MixedItemTag } from "@memorang/types/src/tag";

export const calculateTagPoints = (tags: MixedItemTag[] = []) => {
	let pointsEarned = 0;
	let totalPoints = 0;

	for (const tag of tags) {
		pointsEarned += tag.numPointsEarned || tag.numCorrect || 0;
		totalPoints += tag.numTotalPoints || tag.numItems || 0;
	}

	return { pointsEarned, totalPoints };
};

export const calculateTotalItemsPoints = (items: BaseItemSchema[] = []) => {
	let pointsEarned = 0;
	let totalPoints = 0;

	for (const item of items) {
		pointsEarned += item.answer?.correct ? 1 : 0;
		totalPoints += 1;
	}

	return { pointsEarned, totalPoints };
};

export const findLowestLevelTag = (tags: MixedItemTag[]): MixedItemTag => {
	if (!tags.length) {
		return {} as MixedItemTag;
	}

	return tags.reduce((_, tag) => {
		return tag.children?.length ? findLowestLevelTag(tag.children) : tag;
	}, tags[0]);
};

export const formatDate = () => {
	const date = new Date();
	return date
		.toLocaleDateString("en-GB", {
			day: "2-digit",
			month: "2-digit",
			year: "numeric",
		})
		.replace(/\//g, ".");
};
